<div class="upload-container align-items-center" [style]="fileName ? 'border:solid 2px #41b760;border-radius:5px': '' ">
  <div class="align-items-center">
    <div class="mat-img" (dragover)="onDragOver($event)" (drop)="dropAttachFiles($event)" *ngIf="!fileName">
      <div class="mt-2">
        <mat-icon class="icon-c-folder" svgIcon="upload-icon" aria-hidden="false"></mat-icon>
      </div>
      <div class="mt-3">
        <label>Arrastre o seleccione un archivo</label>
      </div>
      <label class="btn button-blue btn-upload" for="id"><i class="fa fa-plus"></i>Seleccionar Archivos</label>
      <input type="file" id="id" style="display:none" accept=".xlsm, .XLSM" (change)="dropAttachFiles($event, notFoundEmployees)"/>
      <input type="file" id="id" style="display:none" accept=".xlsm, .XLSM" (change)="dropAttachFiles($event, notFoundEmployees)"/>
    </div>
    
    <div class="wrapper-upload-file mat-img mb-4" *ngIf="fileName">
      <div class="d-flex justify-content-end" style="padding-bottom: 0px;">
        <button type="button" class="btn" (click)="cleanFile()" style="padding-bottom: 0px;">
          <mat-icon class="icon-c-folder delete" aria-hidden="false">close</mat-icon>
        </button>  
      </div>
      <div class="col-12">
        <img class="img-excel" src="https://s3.amazonaws.com/dev.structure.files/assets/zeus-front-broadcast/icons8-excel-48.png">
      </div>
      <div class="col-12 file-name">
        <strong>{{ fileName }}</strong>
      </div>
    </div>
  </div>
</div>

